module.exports = __webpack_public_path__ + "img/9788954613347.b68c97be.jpg";